// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"22caed24","238":"b2f9490b","239":"e18ab1d7","455":"4986ec07","557":"b74c5e6e","762":"60d6370c"}[chunkId] + ".chunk.js";
};